import Banner from "./Banner";
import MainView from "./MainView";
import HomeView from "./HomeView";

import React from "react";
import { toast } from "react-toastify";
import Tags from "./Tags";
import agent from "../../agent";
import { connect } from "react-redux";
import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  APPLY_TAG_FILTER,
} from "../../constants/actionTypes";
import LandingPage from "./LandingPage";

const Promise = global.Promise;

const mapStateToProps = (state) => ({
  ...state.home,
  appName: state.common.appName,
  token: state.common.token,
});

const mapDispatchToProps = (dispatch) => ({
  onClickTag: (tag, pager, payload) =>
    dispatch({ type: APPLY_TAG_FILTER, tag, pager, payload }),
  onLoad: (tab, pager, payload) =>
    dispatch({ type: HOME_PAGE_LOADED, tab, pager, payload }),
  onUnload: () => dispatch({ type: HOME_PAGE_UNLOADED }),
});

class Home extends React.Component {

  constructor(props) {
    super();
  this.state = {
  
    isloading: false,
    isLoggedIn: false,
   
  };
  }
  componentDidMount() {
    const tab = this.props.token ? "feed" : "all";
    const articlesPromise = this.props.token
      ? agent.Articles.feed
      : agent.Articles.all;

    this.props.onLoad(
      tab,
      articlesPromise,
      Promise.all([agent.Tags.getAll(), articlesPromise()])
    );
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentDidMount() {

 


   
    if (localStorage.getItem("isLoggedIn") === null) {
      this.setState((state) => ({
        isLoggedIn: false,
      }));
    }else{

      this.setState((state) => ({
        isLoggedIn: JSON.parse(window.localStorage.getItem("isLoggedIn")),
      }));
    }

    try {
      const rawUser = window.localStorage.getItem("UserData");
      const user = rawUser ? JSON.parse(rawUser) : null;
      if (user && (user.verify_mobile == "0" && user.verify_email == "0")) {
        toast.error("Please verify your email and mobile number in Profile", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      }
      else if (user && (user.verify_mobile == "0")) {
        toast.error("Please verify your mobile number in Profile", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      }
      else if (user && (user.verify_email == "0")) {
        toast.error("Please verify your email in Profile", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      }
    } catch (e) {  }
  }
  render() {
    return (
      <div className="home-page">
        {this.state.isLoggedIn == true && <Banner />}

        {this.state.isLoggedIn == true ? (
          <div className="container page">
            <div className="row">
              <MainView />

              {/* <div className="col-md-3">
              <div className="sidebar">

                <p>Popular Tags</p>

                <Tags
                  tags={this.props.tags}
                  onClickTag={this.props.onClickTag} />

              </div>
            </div> */}
            </div>
          </div>) : (<LandingPage />)}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
